(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-heel-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tc-heel-finder')) {
    customElements.define('tc-heel-finder',class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready=true;
        this.form=this.querySelector('.tc-heel-finder__form');
        this.grid=this.querySelector('.tc-heel-finder__grid');
        this.more=this.querySelector('.tc-heel-finder__more');
        this.count=this.querySelector('.tc-heel-finder__count');
        this.limit=Number(this.dataset.pageSize)||8;
        this.rows=[...this.querySelectorAll('.tc-heel-finder__card')].map((card,index)=>{
          const options=JSON.parse(card.dataset.options);
          const variants=JSON.parse(card.dataset.variants);
          const sizeIndex=options.findIndex(name=>/size/i.test(name));
          const colourIndex=options.findIndex(name=>/colou?r/i.test(name));
          const title=card.dataset.title;
          const height=title.match(/\b(\d+(?:\.\d+)?)\s*[- ]?\s*inch(?:es)?\b/i)?.[1]||'';
          const handles=JSON.parse(card.dataset.collections);
          const colourMap=[['nude-heels','Nude'],['golden-heels','Gold'],['silver-heels','Silver'],['cocoa-brown-heels','Brown']];
          let colour='';
            if(/\bwhite\b/i.test(title)) colour='White';
            else if(/\bleopard\b/i.test(title)) colour='Leopard';
            else if(/\b(?:nude|beige)\b/i.test(title)) colour='Nude';
            else if(/\bbrown\b/i.test(title)) colour='Brown';
            else if(/\bgold(?:en)?\b/i.test(title)) colour='Gold';
            else if(/\bsilver\b/i.test(title)) colour='Silver';
            else if(colourIndex>=0) colour=variants[0]?.options[colourIndex]||'';
          if(!colour) colour=colourMap.find(([handle])=>handles.includes(handle))?.[1]||'';
          return {card,index,title,height,colour,sizeIndex,variants,price:Number(card.dataset.price),url:card.dataset.url,select:card.querySelector('.tc-heel-finder__quick select')};
        });
        this.colourLabels={Nude:this.dataset.nude,Gold:this.dataset.gold,Silver:this.dataset.silver,Brown:this.dataset.brown,White:this.dataset.white,Leopard:this.dataset.leopard};
        this.money=new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency||'PHP'});
        const addOptions=(name,values,unit='')=>{
          [...new Set(values.filter(Boolean))].sort((a,b)=>String(a).localeCompare(String(b),undefined,{numeric:true})).forEach(value=>{
            const option=document.createElement('option');option.value=value;option.textContent=(name==='colour'?(this.colourLabels[value]||value):value)+unit;this.form.elements[name].append(option);
          });
        };
        addOptions('size',this.rows.flatMap(row=>row.sizeIndex<0?[]:row.variants.map(v=>v.options[row.sizeIndex])));
        addOptions('height',this.rows.map(row=>row.height),' '+this.dataset.heightUnit);
        addOptions('colour',this.rows.map(row=>row.colour));
        this.rows.forEach(row=>row.select.addEventListener('change',()=>this.selectVariant(row)));
        this.form.hidden=false;
        this.form.addEventListener('submit',event=>event.preventDefault());
        this.form.addEventListener('input',()=>{this.limit=Number(this.dataset.pageSize)||8;this.update();});
        this.form.addEventListener('reset',()=>{requestAnimationFrame(()=>{this.limit=Number(this.dataset.pageSize)||8;this.update();});});
        this.querySelector('[data-reset]').addEventListener('click',()=>this.form.reset());
        this.more.addEventListener('click',()=>{const next=this.matchedRows?.[this.limit];this.limit+=Number(this.dataset.pageSize)||8;this.update();next?.card.querySelector('a')?.focus({preventScroll:true});});
        this.querySelector('.tc-heel-finder__help').addEventListener('click',event=>{
          event.preventDefault();const guide=this.querySelector('.tc-fit-guide');guide.open=true;guide.querySelector('summary').focus();
        });
        this.update();
      }
      selectVariant(row) {
        const variant=row.variants.find(v=>String(v.id)===row.select.value);
        if(!variant)return;
        const url=new URL(row.url,location.origin);url.searchParams.set('variant',variant.id);
        row.card.querySelectorAll('a').forEach(a=>a.href=url.pathname+url.search);
        row.card.querySelector('.tc-heel-finder__price').textContent=this.money.format(variant.price/100);
      }
      update() {
        const fields=this.form.elements;
        const size=fields.size.value;
        const height=fields.height.value;
        const colour=fields.colour.value;
        const budget=fields.budget.value;
        const max=budget===''?Infinity:Math.max(0,Number(budget))*100;
        const available=fields.available.checked;
        this.matchedRows=this.rows.filter(row=>{
          const matching=row.variants.filter(v=>(!size||(row.sizeIndex>=0&&String(v.options[row.sizeIndex])===size))&&(!available||v.available)&&v.price<=max);
          row.matching=matching;
          row.matchPrice=matching.length?Math.min(...matching.map(v=>v.price)):Infinity;
          return matching.length&&(!height||row.height===height)&&(!colour||row.colour===colour);
        });
        const sort=fields.sort.value;
        this.matchedRows.sort((a,b)=>sort==='price-up'?a.matchPrice-b.matchPrice:sort==='price-down'?b.matchPrice-a.matchPrice:sort==='name'?a.title.localeCompare(b.title):a.index-b.index);
        this.rows.forEach(row=>{row.card.hidden=true;});
        this.matchedRows.forEach((row,index)=>{
          this.grid.append(row.card);row.card.hidden=index>=this.limit;
          const target=row.matching.find(v=>v.available)||row.matching[0];
          const url=new URL(row.url,location.origin);
          if(size&&target)url.searchParams.set('variant',target.id);
          row.card.querySelectorAll('a').forEach(a=>a.href=url.pathname+url.search);
          row.card.querySelector('.tc-heel-finder__price').textContent=this.money.format(row.matchPrice/100);
          const sizeChanged=row.filterSize!==size;
          row.filterSize=size;
          if(sizeChanged) row.select.value=size&&target?.available?String(target.id):'';
          this.selectVariant(row);
          const note=row.card.querySelector('.tc-heel-finder__match');
          note.textContent=[size?fields.size.previousElementSibling.textContent+': '+size:'',row.height?row.height+' '+this.dataset.heightUnit:'',this.colourLabels[row.colour]||row.colour].filter(Boolean).join(' · ');
          note.hidden=!note.textContent;
        });
        this.count.textContent=this.dataset.count.replace('[shown]',Math.min(this.limit,this.matchedRows.length)).replace('[total]',this.matchedRows.length);
        this.more.hidden=this.limit>=this.matchedRows.length;
        this.querySelector('.tc-heel-finder__empty').hidden=this.matchedRows.length!==0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tc-home-hero')) {
    customElements.define('tc-home-hero', class extends HTMLElement {
      connectedCallback() {
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = [];
        this.resetMotion = () => {
          this.observer?.disconnect();
          this.animations.forEach(animation => animation.cancel());
          this.animations = [];
          if (this.motionQuery.matches || this.dataset.motion !== 'true' || !('IntersectionObserver' in window)) return;
          const main = this.closest('main');
          if (!main) return;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.observer.unobserve(entry.target);
              const animation = entry.target.animate([
                { opacity:.35, transform:'translateY(18px)' },
                { opacity:1, transform:'translateY(0)' }
              ], { duration:600, easing:'cubic-bezier(.2,.7,.2,1)' });
              this.animations.push(animation);
              animation.onfinish = () => { this.animations = this.animations.filter(item => item !== animation); };
            });
          }, { threshold:.12 });
          main.querySelectorAll('h2, .image-with-text__media').forEach(element => this.observer.observe(element));
        };
        this.motionQuery.addEventListener('change',this.resetMotion);
        document.addEventListener('shopify:section:load',this.resetMotion);
        this.resetMotion();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.animations?.forEach(animation => animation.cancel());
        this.motionQuery?.removeEventListener('change',this.resetMotion);
        document.removeEventListener('shopify:section:load',this.resetMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
